import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { TabBox } from './ui/tab-box'

import s from './styles.module.scss'

interface CalendarTabsProps {
  checkinDate?: string
  checkoutDate?: string
  activeTab: 'checkin' | 'checkout' | null
  onReset?: (tab: 'checkin' | 'checkout') => void
}

export const CalendarTabs: FC<CalendarTabsProps> = ({
  checkinDate,
  checkoutDate,
  activeTab,
  onReset,
}) => {
  const { t } = useTranslation()

  const handleReset =
    (tab: 'checkin' | 'checkout') => (e: React.MouseEvent) => {
      e.stopPropagation()
      onReset?.(tab)
    }

  return (
    <div className={s.container}>
      <TabBox
        date={checkinDate}
        label={t('kyrgyzstan_block.calendar.checkin')}
        isActive={activeTab === 'checkin'}
        onReset={handleReset('checkin')}
      />
      <TabBox
        date={checkoutDate}
        label={t('kyrgyzstan_block.calendar.checkout')}
        isActive={activeTab === 'checkout'}
        onReset={handleReset('checkout')}
      />
    </div>
  )
}
